import { TrendingUp } from 'lucide-react'
import React from 'react'

const Card = (props) => {
  const {
    isMobile,
    width,
    isSelected,
    isSuggested,
    label,
    price,
    onClick,
    description
  } = props

  return (
    <div
      className={`sa-option-card ${isSelected ? "selected" : ""} ${
        isSuggested ? "suggested" : ""
      } ${isMobile ? "carousel-card" : ""}`}
      style={isMobile && width ? { width: `${width}px` }: undefined}
    >
      <div className="sa-option-main">
        {isSuggested && (
          <div
            className="sa-badge sa-badge-suggested"
          >
            <TrendingUp />
            <span>Più scelto</span>
          </div>
        )}
        <h4 className="sa-option-title">{label}</h4>
        <div>
          <p className='sa-option-description'>{description}</p>
        </div>
      </div>
      <div className="sa-option-side">
        <p className="sa-option-price">€{price}</p>
        <button 
          className={`sa-option-cta ${isSelected ? "selected" : ""}`}
          onClick={onClick}
        >
          {isSelected ? "Deseleziona" : "Seleziona"}
        </button>
      </div>
    </div>
  )
}

export default Card